import React from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { FormHelperText, Stack } from '@mui/material'
import Grid from '@mui/material/Grid'
import { WarrantEntity } from '../../../types/WarrantEntity'
import { RegisteredIsinField } from '../../../components/fields/IsinField'
import { RegisteredCheckBox } from '../../../components/fields/CheckBox'
import { CommentsFields } from '../shared/AdminCommentsFields'
import { RegisteredTextField } from '../../../components/fields/TextField'

export function BasicData({
    setIsCustomFormDirty,
    warrant,
}: {
    setIsCustomFormDirty: React.Dispatch<React.SetStateAction<boolean>>
    warrant: WarrantEntity
}) {
    const formMethods = useFormContext()
    const isNameFieldDisabled = warrant.instrumentId !== null

    return (
        <FormProvider {...formMethods}>
            <Grid container spacing={2} sx={{ marginY: 4 }}>
                <Grid size={{ xs: 12, md: 3 }}>
                    <RegisteredTextField disabled={isNameFieldDisabled} label='Namn' name='name' />
                    {isNameFieldDisabled && (
                        <FormHelperText>Instrumentets namn har företräde framför optionens namn.</FormHelperText>
                    )}
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <RegisteredIsinField
                        name={warrant.instrumentId ? 'instrumentIsin' : 'isinWarrant'}
                        label='ISIN'
                        warrantId={warrant.id}
                        fullWidth
                        disabled={!!warrant.instrumentId}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}>
                    <RegisteredCheckBox name='unlisted' label='Onoterad' formMethods={formMethods} />
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}>
                    <Stack direction='column'>
                        <RegisteredCheckBox name='issuesAdjustPrice' label='Justera teckningskurs vid nyemissioner' />
                        <RegisteredCheckBox name='cancelled' label='Avbruten option' />
                    </Stack>
                </Grid>
            </Grid>
            <CommentsFields setIsCustomFormDirty={setIsCustomFormDirty} />
        </FormProvider>
    )
}
